import { call } from '../funcStore';

const styles = {
  header: {
    padding: '16px 24px',
    background: '#2d2a4a',
  },
  headerLogo: {
    border: 'none',
    background: 'none',
    padding: 0,
    color: '#fff',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
};

function Header() {
  const handleLogoClick = () => {
    call('app.navigateToHome');
  };

  return (
    <header style={styles.header}>
      <button
        type="button"
        style={styles.headerLogo}
        onClick={handleLogoClick}
      >
        VTuber検索
      </button>
    </header>
  );
}

export default Header;
